import type { FaireProductEntity } from "../../entity_types/product";

export const p_3d38pr7bpq: FaireProductEntity = {
  token: "p_3d38pr7bpq",
  type: "product",
  name: "Presley Pedestal Vase | White",
  brandToken: "b_tthhaz7z5x",
  brandName: "Jungle Club",
  imageUrl:
    "https://cdn.faire.com/fastly/b4d529fca8815db6aeefc301b927d3e07031380747401d0fb5026adb88c17981.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba9ea7a78abd2b8feb93fe081bae40b117dd27b36bd7ed3d3456409e8968a3b6.png",
    "https://cdn.faire.com/fastly/2b17c1bfd0793446299bc9e66abf225e1523e8f90c7a07aeaa63a714279d0b2f.jpeg",
    "https://cdn.faire.com/fastly/7eb24d222c4866f99685933d43f5bb454e1510901b50ff429de58e889a01a2a3.png",
  ],
  priceDollars: 11,
  description:
    'Perfect for a stunning floral arrangement, succulent + cacti arrangements, and more. The Presley Pedestal Vase in the white features a ribbed pedestal that gives it a stylish texture that\'s just enough to stand out from the crowd! \n\n.        No Drainage\n.        Material | Ceramic\n.        3.75" dimensions | 3.75" diameter x 2.5" high\n.        5.5" dimensions | 5.5” diameter x 4.375” high \n.        6" dimensions | 6" diameter x 4.25\' high\n.        8" dimensions | 8” diameter x 5” high\n.        Packed with EPE foam - environmentally friendly and 100% recyclable\n.        Imported',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:59.459Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
